<template>
  <div v-show="show" @click="close()">
    <div class="chat-emotion customer-transfer-panel" :style="{ left: x + 'px', top: y + 'px' }" @click.stop>
      <header class="transfer-header">
        <span class="transfer-title">{{ title }}</span>
        <button type="button" class="transfer-close" aria-label="关闭" @click="close">
          <i class="el-icon-close"></i>
        </button>
      </header>

      <div class="transfer-search">
        <el-input v-model="searchKeyword" clearable size="small" placeholder="搜索客服或小组" class="transfer-search-input">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>

      <p class="transfer-section-label">在线客服</p>

      <!-- <el-scrollbar class="emotion-scroll transfer-scroll">
        <ul class="transfer-list">
          <li v-for="agent in filteredAgents" :key="agentKey(agent)" class="transfer-row" @click="onSelect(agent)">
            <head-image
              :id="agent.userId || agent.id"
              :name="displayName(agent)"
              :url="agent.headImage || agent.headImageThumb"
              :size="36"
              radius="50%"
              :online="isOnlineStatus(agent)"
              :isShowUserInfo="false"
            />
            <div class="transfer-meta">
              <div class="transfer-name">{{ displayName(agent) }}</div>
              <div class="transfer-status" :class="statusClass(agent)">{{ statusText(agent) }}</div>
            </div>
          </li>
        </ul>
        <div v-if="!filteredAgents.length" class="sticker-empty">暂无匹配的客服或小组</div>
      </el-scrollbar> -->
      <CusFixedList class="emotion-scroll transfer-scroll" :items="filteredOnLineList" :item-size="60" key-field="id"
        empty-text="暂无在线的客服" :loading="onLineListLoading">
        <template v-slot="{ item }">
          <div class="transfer-row" role="listitem" @click="onSelect(item)">
            <head-image :id="item.userId || item.id" :name="item.nickName" :url="item.headImage || item.headImageThumb"
              :size="36" radius="50%" :online="true" :isShowUserInfo="false" />
            <div class="transfer-meta">
              <div class="transfer-name">{{ item.nickName }}</div>
              <div class="transfer-status transfer-status--online">在线</div>
            </div>
          </div>
        </template>
      </CusFixedList>
    </div>
  </div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import CusFixedList from "./cus-recycle-scroller.vue";

/**
 * 与 ChatEmotion 相同：top = pos.y - 整块面板近似高度（表情为 294）。
 * 本面板无固定 height，仅 .emotion-scroll 为 220px，总高约345（随样式微调时可改此值）。
 */
const TRANSFER_PANEL_HEIGHT = 355;

export default {
  name: "CustomerServiceCard",
  components: {
    HeadImage,
    CusFixedList
  },
  props: {
    title: {
      type: String,
      default: "将会话转接至..."
    }
  },
  data() {
    return {
      show: false,
      searchKeyword: "",
      pos: {
        x: 0,
        y: 0
      },
      onLineList: [],
      onLineListLoading: false
    };
  },
  computed: {
    /** 与 ChatEmotion 一致：x = pos.x - 22 */
    x() {
      return this.pos.x - 22;
    },
    /** 与 ChatEmotion 一致：y = pos.y - 面板总高度 */
    y() {
      return this.pos.y - TRANSFER_PANEL_HEIGHT;
    },
    // 搜索列表 根据 nickName 去模糊搜索
    filteredOnLineList() {
      if (!this.searchKeyword) {
        return this.onLineList;
      }

      const keyword = this.searchKeyword.toLowerCase();
      return this.onLineList.filter((item) => item.nickName && item.nickName.toLowerCase().includes(keyword));
    }
  },
  methods: {
    open(pos) {
      this.pos = pos;
      this.show = true;
      this.searchKeyword = "";
      this.getOnlineList();
    },
    close() {
      this.show = false;
      this.$emit("close");
    },
    onSelect(agent) {
      this.$emit("select", agent);
      this.close();
    },
    // 获取在线客服列表
    getOnlineList() {
      this.onLineListLoading = true;
      this.$http({
        url: "/customer/transfer/online",
        method: "POST"
      })
        .then((res) => {
          // console.log("res", res);
          this.onLineList = res;
        })
        .catch(() => {
          this.onLineList = [];
        })
        .finally(() => {
          this.onLineListLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.chat-emotion.customer-transfer-panel {
  position: fixed;
  width: 318px;
  box-sizing: border-box;
  padding: 8px 10px 10px;
  background-color: #fff;
  box-shadow: var(--im-box-shadow-lighter);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}

.transfer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 4px 10px;
  flex-shrink: 0;
}

.transfer-title {
  margin: 0;
  font-size: 16px;
  font-weight: 350;
  color: #0f172a;
  line-height: 1.3;
}

.transfer-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;

  i {
    font-size: 16px;
  }

  &:hover {
    background: var(--im-background-active-dark, #f1f5f9);
    color: #334155;
  }
}

.transfer-search {
  padding: 0 4px 8px;
  flex-shrink: 0;
  width: 100%;
}

.transfer-search-input :deep(.el-input__inner) {
  height: 40px;
  line-height: 40px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid transparent;
  padding-left: 32px;

  &:focus {
    background: #fff;
    border-color: var(--im-color-primary, #409eff);
  }
}

.transfer-search-input :deep(.el-input__prefix) {
  left: 8px;
}

.transfer-section-label {
  margin: 0 4px 6px;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.4;
  text-align: left;
  flex-shrink: 0;
}

.emotion-scroll.transfer-scroll {
  height: 220px;
}

.transfer-list {
  list-style: none;
  margin: 0;
  padding: 0 2px;
}

.transfer-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
  height: 60px;
  box-sizing: border-box;

  &:hover {
    background: var(--im-background-active-dark, #f8fafc);
  }
}

.transfer-meta {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
}

.transfer-name {
  font-size: 15px;
  font-weight: 500;
  color: #0f172a;
  line-height: 1.3;
}

.transfer-status {
  font-size: 13px;
  line-height: 1.2;
}

.transfer-status--online {
  color: #006859;
}

.transfer-status--busy {
  color: #9333ea;
}

.sticker-empty {
  text-align: center;
  color: var(--im-text-color-light);
  font-size: var(--im-font-size-smaller);
  padding: 12px 0;
}
</style>
